<template>
<div class="mt-3">
  <v-menu
      bottom right
      transition="scale-transition"
      origin="top left" nudge-bottom="32px"
      v-for="(mercado, idx) in listaMercadoDestinoSelecionado" :key="idx+'__chip__md'"
  >
    <template v-slot:activator="{ on }">
      <v-chip color="#e2e6e7" class="mr-1" v-on="on"  >
        <div class="d-flex align-center">
          <span class="chip--text--mercado">
            {{ mercado.cdMercadoDestino | nomearMercadoDestino(listaMercadoDestino) }}
          </span>
          <v-icon class="ml-1" color="#799596" size="16"
                  @click.stop="$emit('selecionarMercadoDestino', {idMercadoDestino: mercado.cdMercadoDestino})">
            fas fa-times-circle
          </v-icon>
        </div>
      </v-chip>
    </template>
    <div class="card--mensagens--chip elevation-1 pa-2" style="background: white; border-radius: 4px;">
      <span style="
font: normal normal normal 12px/16px Roboto, sans-serif;
color: #35565B;
letter-spacing: 0;
">
        Mensagens mercado destino:
      </span>
      <div v-for="(mensagem, idx) in (mensagensMercado(mercado.cdMercadoDestino))" class="mb-1"
           style="
  font: normal normal normal 16px/28px Roboto, sans-serif;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0;
  background: #F2F5F3;
  border: 1px solid #0090E9;
  box-sizing: border-box;
  border-radius: 4px;"
           :key="idx+'__mensagens__unicas'">
        {{ mensagem }}
      </div>
    </div>
  </v-menu>
</div>
</template>
<script>
export default {
  name: 'mercado-destino-chip-group',
  props: {
    mercadosDestino: {
      type: Array,
      default: () => [],
    },
    listaMercadoDestino: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    listaMercadoDestinoSelecionado() {
      return _.uniqWith(this.mercadosDestino, (a,b) => a.cdMercadoDestino === b.cdMercadoDestino)
    },
    mensagensMercado() {
      return (idMercadoDestino) =>
          this.listaMercadoDestino.find(md => md.idMercadoDestino === idMercadoDestino)['mensagensBoletimSanitario']
          .map(mensagens => mensagens.dsMensagemBoletimSanitario)
    },
  },
  filters: {
    nomearMercadoDestino(idMercadoDestino, listaMercados) {
      return listaMercados.find(md => md.idMercadoDestino === idMercadoDestino)['dsMercadoDestino']
    },
    mensagensMercado(idMercadoDestino, listaMercados) {
      return listaMercados.find(md => md.idMercadoDestino === idMercadoDestino)['mensagensBoletimSanitario']
          .map(mensagens => mensagens.dsMensagemBoletimSanitario)
    },
  }
}
</script>
<style scoped lang="scss">

.chip--text--mercado {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #35565B;
}
</style>